module.exports = __webpack_public_path__ + "img/info6.a94d12e4.png";